export const initialState = {
  page: 1,
  size: 20,
  total: 0,
  usersList: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case "setPage": {
      return { page: action.payload };
    }
    default:
      return state;
  }
};
